import { useState } from 'react';
import { Store } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * A store's app icon (`TenantDto.iconUrl`), falling back to a neutral store
 * glyph when the store has none yet or the image fails to load.
 */
export function StoreIcon({
  src,
  className,
}: {
  src: string | null | undefined;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <span
        aria-hidden="true"
        className={cn(
          'flex shrink-0 items-center justify-center bg-[#EEF0F3] text-[#8A909B]',
          className
        )}
      >
        <Store className="size-[42%]" strokeWidth={1.5} />
      </span>
    );
  }

  return (
    <img
      src={src}
      alt=""
      onError={() => setFailed(true)}
      className={cn('shrink-0 object-cover', className)}
    />
  );
}
